<div class="snacks-container">
  <div class="scroll-container">
    @for (item of snacks; track item; let i = $index) {
      <app-snacks-item
        (closeItem)="closeItem(item)"
        [data]="item"
        [index]="i"
        [style.zIndex]="9999 - i"
      [zIndex]="9999 - i"></app-snacks-item>
    }
  </div>
</div>
